import { render, staticRenderFns } from "./ShoppingCar.vue?vue&type=template&id=5ec3f70d"
import script from "./ShoppingCar.vue?vue&type=script&lang=js"
export * from "./ShoppingCar.vue?vue&type=script&lang=js"
import style0 from "./ShoppingCar.vue?vue&type=style&index=0&id=5ec3f70d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports